import { render, staticRenderFns } from "./NorticSelect.vue?vue&type=template&id=7f8e0110&scoped=true&"
import script from "./NorticSelect.vue?vue&type=script&lang=js&"
export * from "./NorticSelect.vue?vue&type=script&lang=js&"
import style0 from "./NorticSelect.vue?vue&type=style&index=0&id=7f8e0110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8e0110",
  null
  
)

export default component.exports